import { useState } from "react";

import PriceRuleForm from "../../../components/forms/setup/priceRules/PriceRuleForm";
import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function PriceRulesViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [priceRules, setPriceRules] = useState({ data: [], total: 0 });
  const [slideOver, setSlideOver] = useState({
    open: false,
    childComponent: null,
  });
  const notify = (message) =>
    addSnackbar(
      new SnackbarData(generateUniqueNumber(), message, SnackbarType.Success),
    );

  const getPriceRules = async (search = "", page = 1) => {
    setLoading(true);
    const result = await makePostApiCall("priceRules", { search, page });
    setLoading(false);
    if (result.success) setPriceRules(result.data);
    else if (result.errorStatus === 401) logout();
  };

  const save = async (priceRule, values) => {
    const result = priceRule
      ? await makePutApiCall(`priceRules/${priceRule.id}`, values)
      : await makePostApiCall("createPriceRule", values);
    if (result.success) {
      notify(priceRule ? "Price rule updated" : "Price rule added");
      setSlideOver({ open: false, childComponent: null });
      getPriceRules("", 1);
    } else if (result.errorStatus === 401) logout();
  };

  const openForm = (priceRule = null) =>
    setSlideOver({
      open: true,
      childComponent: (
        <PriceRuleForm
          priceRule={priceRule}
          isEdit={Boolean(priceRule)}
          setOpen={setSlideOver}
          actionCall={(values) => save(priceRule, values)}
        />
      ),
    });

  const archivePriceRule = async (id) => {
    const result = await makePostApiCall(`deletePriceRule/${id}`, {});
    if (result.success) {
      notify("Price rule archived");
      getPriceRules("", 1);
    } else if (result.errorStatus === 401) logout();
  };

  return {
    loading,
    priceRules,
    slideOver,
    setSlideOver,
    getPriceRules,
    openForm,
    archivePriceRule,
  };
}
